import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../../store/reducers/preferences';
import {useTranslation} from 'react-i18next';
import {isNull} from 'lodash';
import clsx from 'clsx';
import {Chip, FormLabel, Stack} from '@mui/material';
import {OPTION_BUTTONS_DEFAULT_GAP, useSettingsStyles} from '../userProperties';

const DEFAULT_STATE = {
    snackbar: {vertical: 'bottom', horizontal: 'left'},
};

const SnackbarPosition = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [position, setPosition] = useState(!isNull(agylePreference?.snackbar) ? agylePreference?.snackbar : DEFAULT_STATE.snackbar);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setPosition(DEFAULT_STATE.snackbar);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (val, type) => {
        let clone = {...position}
        clone[type] = val;
        setPosition(clone);
        props.onChange('snackbar', clone);
    };

    return (
        <div>
            <FormLabel>
                {t('Vertical')}
            </FormLabel>

            <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{mb: 1, mt: .5}}>
                <Chip label="Top" className={clsx(position.vertical === 'top' && classes.activeChip)} onClick={handleChange.bind(null, 'top', 'vertical')} />

                <Chip label="Bottom" className={clsx(position.vertical === 'bottom' && classes.activeChip)} onClick={handleChange.bind(null, 'bottom', 'vertical')} />
            </Stack>

            <FormLabel>
                {t('Horizontal')}
            </FormLabel>

            <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{my: .5}}>
                <Chip label="Left" className={clsx(position.horizontal === 'left' && classes.activeChip)} onClick={handleChange.bind(null, 'left', 'horizontal')} />

                <Chip label="Center" className={clsx(position.horizontal === 'center' && classes.activeChip)} onClick={handleChange.bind(null, 'center', 'horizontal')} />

                <Chip label="Right" className={clsx(position.horizontal === 'right' && classes.activeChip)} onClick={handleChange.bind(null, 'right', 'horizontal')} />
            </Stack>
        </div>
    );
});

export default SnackbarPosition;